module.exports = __webpack_public_path__ + "static/media/logo_inline_w.488b0311.svg";